import { Card, CardContent } from '@/components/ui/card'
import { cn } from '@/lib/tailwind.utils'
import { useNavigate } from 'react-router-dom'
import HomeContent from '../../../../src/components/SectionContent'
import { MODULES } from './ModuleOverviewData'
import ModuleOverviewItem from './ModuleOverviewItem'
import SectionHeading from './SectionHeading'

const ModuleOverview = () => {
  const navigate = useNavigate()

  return (
    <HomeContent className="pt-10">
      <SectionHeading>Module overview</SectionHeading>
      <Card className="shadow-none border-transparent bg-background">
        <CardContent className="p-0">
          <div className="grid grid-cols-1 md:grid-cols-2 ">
            {MODULES.map((module, i) => {
              const isLeft = i % 2 === 0
              const isLastRow = i >= MODULES.length - 2

              return (
                <div
                  key={module.id}
                  className={cn(
                    'relative p-6',
                    !isLastRow && 'md:border-b md:border-transparent',
                    isLeft && 'md:border-r md:border-transparent',
                  )}
                >
                  <ModuleOverviewItem
                    title={module.title}
                    description={module.description}
                    actionLabel={module.actionLabel}
                    Icon={module.icon}
                    onAction={() => navigate(module.path)}
                    enhanced={module.enhanced}
                  />
                </div>
              )
            })}
          </div>
        </CardContent>
      </Card>
    </HomeContent>
  )
}

export default ModuleOverview
